// Menu data for Kiraak Mandi. All prices in OMR.
// Edit the list below to update the menu without touching components.

export const WHATSAPP_NUMBER = "96871231343"; // Oman number, no '+'
export const RESTAURANT_NAME = "Kiraak Mandi";

export const HERO_SLIDES = [
    {
        id: "s1",
        image:
            "https://static.prod-images.emergentagent.com/jobs/78ca2710-f263-4561-8699-640b630fb563/images/344243786d45953ceea4453178df6c92cc67bf7a85ac46e903fb9ec92367d842.png",
        eyebrow: "SIGNATURE SPECIAL",
        title: "Arabian Lamb Mandi",
        subtitle:
            "Wood-smoked basmati, slow-cooked tender lamb, served the traditional way.",
        cta: "Order on WhatsApp",
    },
    {
        id: "s2",
        image:
            "https://static.prod-images.emergentagent.com/jobs/78ca2710-f263-4561-8699-640b630fb563/images/8bc1739b6805c0a5ed6a9e5d30206ffc630ae5d71a6b1810e29fdc0d6dbd4ef4.png",
        eyebrow: "HYDERABADI HERITAGE",
        title: "Authentic Dum Biryani",
        subtitle:
            "Sealed on slow dum, layered with saffron, caramelised onions and aromatic spices.",
        cta: "Order Now",
    },
    {
        id: "s3",
        image:
            "https://images.pexels.com/photos/7625056/pexels-photo-7625056.jpeg",
        eyebrow: "MUGHLAI CLASSIC",
        title: "Butter Chicken & Garlic Naan",
        subtitle:
            "Tandoor-charred chicken drowned in silky tomato-cream gravy. A royal favourite.",
        cta: "Order Now",
    },
    {
        id: "s4",
        image:
            "https://images.pexels.com/photos/33990731/pexels-photo-33990731.jpeg",
        eyebrow: "CHARCOAL GRILLED",
        title: "Mixed Kebab Platter",
        subtitle:
            "Seekh, malai, tikka and reshmi — a smoky celebration straight from our tandoor.",
        cta: "Order Now",
    },
    {
        id: "s5",
        image:
            "https://images.pexels.com/photos/34159106/pexels-photo-34159106.jpeg",
        eyebrow: "FAMILY FAVOURITE",
        title: "Kerala Chicken Biryani",
        subtitle:
            "Short-grain fragrant rice with spicy coastal-style masala chicken. Soulful.",
        cta: "Order Now",
    },
];

export const CATEGORIES = [
    { id: "all", label: "All" },
    { id: "mandi", label: "Mandi" },
    { id: "biryani", label: "Biryani" },
    { id: "mughalai", label: "Mughalai" },
    { id: "starters", label: "Starters" },
    { id: "breads", label: "Breads & Rice" },
    { id: "beverages", label: "Beverages" },
];

export const MENU = [
    // MANDI
    {
        id: "m1",
        name: "Arabian Lamb Mandi",
        desc: "Slow-cooked lamb on the bone, smoked basmati rice, cashews & raisins.",
        price: 6.5,
        category: "mandi",
        tag: "Chef's Pick",
        image:
            "https://static.prod-images.emergentagent.com/jobs/78ca2710-f263-4561-8699-640b630fb563/images/344243786d45953ceea4453178df6c92cc67bf7a85ac46e903fb9ec92367d842.png",
    },
    {
        id: "m2",
        name: "Chicken Mandi",
        desc: "Half chicken, smoked long-grain rice, house mandi spice blend.",
        price: 3.9,
        category: "mandi",
        tag: "Best Seller",
        image:
            "https://images.pexels.com/photos/34159106/pexels-photo-34159106.jpeg",
    },
    {
        id: "m3",
        name: "Fish Mandi",
        desc: "Fresh catch, marinated and smoked with fragrant mandi rice.",
        price: 4.5,
        category: "mandi",
        image:
            "https://images.pexels.com/photos/5848696/pexels-photo-5848696.jpeg",
    },

    // BIRYANI
    {
        id: "b1",
        name: "Hyderabadi Dum Biryani",
        desc: "Long-grain basmati layered with succulent chicken on traditional dum.",
        price: 2.8,
        category: "biryani",
        tag: "Signature",
        image:
            "https://static.prod-images.emergentagent.com/jobs/78ca2710-f263-4561-8699-640b630fb563/images/8bc1739b6805c0a5ed6a9e5d30206ffc630ae5d71a6b1810e29fdc0d6dbd4ef4.png",
    },
    {
        id: "b2",
        name: "Kerala Chicken Biryani",
        desc: "Short-grain kaima rice, coastal spices, soft masala chicken.",
        price: 2.6,
        category: "biryani",
        image:
            "https://images.pexels.com/photos/34159106/pexels-photo-34159106.jpeg",
    },
    {
        id: "b3",
        name: "Mutton Dum Biryani",
        desc: "Tender mutton, saffron-milk, slow-sealed on coal dum. Royal.",
        price: 3.9,
        category: "biryani",
        image:
            "https://images.pexels.com/photos/33947401/pexels-photo-33947401.jpeg",
    },

    // MUGHALAI
    {
        id: "mg1",
        name: "Butter Chicken",
        desc: "Tandoor chicken in tomato-cashew gravy, finished with butter & cream.",
        price: 2.9,
        category: "mughalai",
        tag: "Must Try",
        image:
            "https://static.prod-images.emergentagent.com/jobs/78ca2710-f263-4561-8699-640b630fb563/images/3a20949b742c4bc3157af0966d205b086e82cb7edebe1f32fbc931282b30840b.png",
    },
    {
        id: "mg2",
        name: "Mughalai Chicken Korma",
        desc: "Yogurt, saffron, almonds — a creamy royal preparation.",
        price: 3.2,
        category: "mughalai",
        image:
            "https://images.pexels.com/photos/12737918/pexels-photo-12737918.jpeg",
    },
    {
        id: "mg3",
        name: "Rogan Josh",
        desc: "Kashmiri-style mutton curry with deep-red chilli and fennel aroma.",
        price: 3.6,
        category: "mughalai",
        image:
            "https://images.pexels.com/photos/12737918/pexels-photo-12737918.jpeg",
    },

    // STARTERS
    {
        id: "s1",
        name: "Mixed Kebab Platter",
        desc: "Seekh, malai, chicken tikka and reshmi kebab from the tandoor.",
        price: 3.5,
        category: "starters",
        tag: "Sharing",
        image:
            "https://images.pexels.com/photos/33233601/pexels-photo-33233601.jpeg",
    },
    {
        id: "s2",
        name: "Chicken Seekh Kebab",
        desc: "Spiced minced chicken skewers, char-grilled.",
        price: 2.2,
        category: "starters",
        image:
            "https://images.pexels.com/photos/33233601/pexels-photo-33233601.jpeg",
    },
    {
        id: "s3",
        name: "Chicken 65",
        desc: "Crispy, spicy South-Indian style fried chicken bites.",
        price: 1.9,
        category: "starters",
        image:
            "https://images.pexels.com/photos/33990731/pexels-photo-33990731.jpeg",
    },

    // BREADS & RICE
    {
        id: "br1",
        name: "Butter Naan",
        desc: "Soft tandoor flatbread brushed with butter.",
        price: 0.4,
        category: "breads",
        image:
            "https://images.pexels.com/photos/7625056/pexels-photo-7625056.jpeg",
    },
    {
        id: "br2",
        name: "Garlic Naan",
        desc: "Tandoor naan topped with roasted garlic and coriander.",
        price: 0.5,
        category: "breads",
        image:
            "https://images.pexels.com/photos/7625056/pexels-photo-7625056.jpeg",
    },
    {
        id: "br3",
        name: "Jeera Rice",
        desc: "Basmati rice tempered with cumin & ghee.",
        price: 1.0,
        category: "breads",
        image:
            "https://images.pexels.com/photos/34159106/pexels-photo-34159106.jpeg",
    },

    // BEVERAGES
    {
        id: "bv1",
        name: "Fresh Mint Lemonade",
        desc: "Mint, lime, ice & a hint of rock salt. Refreshingly cooling.",
        price: 0.8,
        category: "beverages",
        image:
            "https://images.unsplash.com/photo-1656936632107-0bfa69ea06de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtaW50JTIwbGVtb25hZGUlMjBkcmlua3N8ZW58MHx8fHwxNzc2Nzc0MDQyfDA&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "bv2",
        name: "Masala Chai",
        desc: "Assam tea, cardamom, ginger and a whisper of clove.",
        price: 0.5,
        category: "beverages",
        image:
            "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    },
    {
        id: "bv3",
        name: "Mango Lassi",
        desc: "Creamy yogurt & ripe Alphonso mango blend.",
        price: 0.9,
        category: "beverages",
        image:
            "https://images.unsplash.com/photo-1571805341302-f857a8559ba9?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    },
];

export const formatPrice = (n) => `${n.toFixed(3)} OMR`;

export const buildWaLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
